var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _g2, _path9, _path0, _path1, _path10, _path11, _path12, _g3, _path13, _path14, _g4, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourIconFour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 96,
    viewBox: "0 0 116 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.245 52.9835C106.381 52.0163 107.275 51.3421 108.242 51.4776C109.209 51.6131 109.883 52.507 109.748 53.4741C109.612 54.4413 108.718 55.1155 107.751 54.98C106.784 54.8445 106.11 53.9506 106.245 52.9835Z",
    fill: "#D0BEDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.463 42.873C109.685 41.2863 111.152 40.1803 112.739 40.4026C114.326 40.6249 115.433 42.0915 115.21 43.6783C114.988 45.265 113.521 46.371 111.934 46.1487C110.347 45.9264 109.24 44.4598 109.463 42.873Z",
    fill: "#D0BEDD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_9185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 71,
    width: 8,
    height: 8
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20061 72.489L0.832642 71.5969L7.074e-06 77.5403L6.36798 78.4324L7.20061 72.489Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_9185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_9185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 71,
    width: 7,
    height: 8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04193 71.6498L6.78969 72.4551L5.9847 78.2012L0.236943 77.3959L1.04193 71.6498Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_9185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_9185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 72,
    width: 7,
    height: 6
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.91581 72.0525C2.32879 71.8301 0.861883 72.935 0.639321 74.5237C0.416991 76.1107 1.5238 77.5762 3.11082 77.7985C4.69784 78.0209 6.16475 76.916 6.38708 75.3289C6.60964 73.7403 5.50283 72.2748 3.91581 72.0525Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_9185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.04242 71.6498L6.79017 72.455L5.98519 78.2011L0.237431 77.3959L1.04242 71.6498Z",
    fill: "#D0BEDD"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_9185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 63,
    width: 6,
    height: 6
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5443 64.472L8.40509 63.8921L7.86388 67.7553L12.0031 68.3352L12.5443 64.472Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_9185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_9185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 63,
    width: 5,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54089 63.9264L12.2769 64.4498L11.7537 68.1848L8.01765 67.6614L8.54089 63.9264Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_9185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_9185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 64,
    width: 5,
    height: 4
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.409 64.1878C9.37747 64.0433 8.42398 64.7615 8.27932 65.7941C8.1348 66.8257 8.85423 67.7783 9.88579 67.9228C10.9174 68.0673 11.8708 67.3491 12.0154 66.3175C12.16 65.2849 11.4406 64.3323 10.409 64.1878Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_9185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5412 63.9265L12.2772 64.4499L11.754 68.1849L8.01796 67.6615L8.5412 63.9265Z",
    fill: "#D0BEDD"
  }))))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4024 36.873C10.6247 35.2863 12.0921 34.1803 13.6788 34.4026C15.2656 34.6249 16.3725 36.0915 16.1502 37.6783C15.9279 39.265 14.4606 40.371 12.8738 40.1487C11.2871 39.9264 10.1801 38.4598 10.4024 36.873Z",
    fill: "#D0BEDD"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.236 62.1575C22.3117 87.0014 47.2597 90.3583 53.002 90.8011C53.778 90.8602 54.5517 90.9211 55.3278 90.9802C61.0699 91.4251 86.2369 91.9468 88.159 67.1049C90.1047 41.9692 64.544 38.8286 59.1985 38.4449C58.5534 38.3983 57.9063 38.3494 57.262 38.2944C51.9201 37.8514 26.1817 37.0218 24.236 62.1575Z",
    fill: "#662D91"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.097 68.619C84.7214 73.4775 83.4815 77.5934 81.3902 80.9445C79.7336 77.051 76.9777 73.877 73.1328 71.4468C67.0241 67.5848 59.9781 66.6749 57.2339 66.4624L57.052 66.4493C56.7219 66.4264 56.3942 66.4016 56.0622 66.3763C55.7345 66.3515 55.4046 66.3264 55.0772 66.2974L54.8936 66.2799C52.1452 66.067 45.0471 65.8826 38.4156 68.7585C34.2435 70.5674 31.029 73.279 28.7911 76.8717C27.2417 73.2397 26.6486 68.9811 27.0263 64.1228C27.8064 54.0593 32.2911 47.1815 40.3574 43.6863C46.9889 40.8104 54.087 40.9948 56.8354 41.2077L57.0174 41.2207C57.3451 41.2456 57.6746 41.2748 58.0023 41.2997C58.3322 41.3247 58.6601 41.3475 58.9921 41.3727L59.174 41.3858C61.9182 41.5983 68.9642 42.5082 75.0729 46.3702C82.5033 51.0694 85.8749 58.5553 85.097 68.619Z",
    fill: "#662D91"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5744 80.9715L41.5973 78.8823C33.6881 78.2692 27.7736 71.3631 28.3867 63.4539C28.9998 55.5448 35.9059 49.6303 43.815 50.2434L70.7921 52.3327C78.7013 52.9457 84.6158 59.8518 84.0027 67.761C83.3898 75.668 76.4814 81.5844 68.5744 80.9715Z",
    fill: "#7A4B9D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3694 49.945L91.8052 31.3908C93.7732 30.9649 95.2589 29.1194 95.0224 26.9074C94.8457 25.2528 93.6364 23.8405 92.0287 23.4125C89.4656 22.7296 87.0351 24.5447 86.8403 27.0585C86.6979 28.9106 87.8109 30.5735 89.4626 31.2101L88.0362 49.6439C85.4467 45.3931 82.0247 42.4368 78.8326 40.4203C71.3966 35.7141 62.9881 34.6189 59.7154 34.3646L59.485 34.3469C59.1718 34.3256 58.8609 34.3023 58.5545 34.2774C58.2331 34.2531 57.9224 34.2278 57.597 34.2011L57.3771 34.1844C54.1065 33.9302 45.6288 33.7187 37.5532 37.2216C34.1455 38.6966 30.3809 41.0342 27.2028 44.7268L28.6137 26.5003C30.5818 26.0745 32.0675 24.2289 31.831 22.017C31.6543 20.3623 30.4449 18.95 28.8373 18.5221C26.2742 17.8391 23.8436 19.6543 23.6488 22.168C23.5064 24.0202 24.6194 25.6831 26.2711 26.3197L24.8354 44.874L24.8333 44.8738C20.4695 44.5367 16.6594 47.7986 16.3203 52.1622L15.912 57.4307C15.7879 59.0461 16.3293 60.5608 17.3068 61.7018C18.0121 62.5251 18.9406 63.1524 20.006 63.4818C20.4235 63.6153 20.8583 63.7015 21.3108 63.7361L22.3341 63.8144L22.3392 63.7617C23.4898 48.8925 31.7558 42.2961 38.4848 39.3805C46.0763 36.085 54.0968 36.2891 57.192 36.5287L57.3993 36.5442C58.0394 36.5988 58.6863 36.6497 59.3105 36.6922L59.5304 36.7089C62.6256 36.9485 70.584 37.9837 77.5742 42.4067C83.7735 46.3242 90.9239 54.1169 89.7735 68.984L89.7685 69.0368L90.9398 69.1271C91.3414 69.159 91.7365 69.1476 92.12 69.1011C93.286 68.9566 94.3527 68.4683 95.2109 67.7322C96.3519 66.7548 97.121 65.3436 97.2453 63.7262L97.6536 58.4576C97.997 54.0944 94.733 50.2842 90.3694 49.945ZM25.9935 22.3488C26.0688 21.3806 26.9175 20.6542 27.8857 20.7295C28.854 20.8047 29.5803 21.6534 29.5051 22.6217C29.4299 23.59 28.5812 24.3163 27.6129 24.2411C26.6446 24.1658 25.9183 23.3171 25.9935 22.3488ZM89.1827 27.2412C89.2579 26.2729 90.1066 25.5466 91.0749 25.6218C92.0432 25.6971 92.7695 26.5458 92.6943 27.5141C92.619 28.4823 91.7703 29.2087 90.802 29.1334C89.8359 29.0584 89.1096 28.2097 89.1827 27.2412Z",
    fill: "#662D91"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_9185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 1,
    width: 84,
    height: 65
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4258 1.25168L105.021 18.6904L93.4961 65.3445L22.9011 47.9058L34.4258 1.25168Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_9185)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.2308 30.901C100.194 31.3861 101.398 33.3557 100.917 35.3007C100.437 37.2456 98.4542 38.4307 96.4906 37.9457C96.2272 37.8806 95.9782 37.7884 95.7449 37.6745L86.7517 55.7771C86.7517 55.7771 71.1134 49.0015 60.4681 46.4047C50.0599 43.8658 33.3243 42.5792 33.3243 42.5792L33.7946 22.3713C33.5352 22.3635 33.2719 22.3291 33.0085 22.264C31.0449 21.779 29.842 19.8069 30.3224 17.862C30.8028 15.917 32.785 14.7343 34.7487 15.2194C36.7147 15.7051 37.9158 17.6741 37.4353 19.619C37.2264 20.465 36.7377 21.1651 36.0851 21.6483C40.6301 27.0849 46.032 30.373 51.4482 30.3761C58.4306 30.3774 63.903 24.9247 66.7319 16.4485C65.5427 15.6049 64.927 14.1052 65.2944 12.6182C65.7748 10.6733 67.7576 9.48817 69.7212 9.97323C71.6873 10.4589 72.8902 12.431 72.4097 14.3759C72.0424 15.8629 70.7993 16.9034 69.3541 17.0962C67.9107 25.9147 70.2147 33.2883 76.3946 36.5384C81.1893 39.0576 87.5008 38.6631 94.0545 35.9681C93.7021 35.2367 93.5956 34.3895 93.8045 33.5436C94.285 31.5987 96.2647 30.4154 98.2308 30.901Z",
    fill: "#FFCA55"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_1_9185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 86,
    width: 4,
    height: 4
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4459 86L88.6299 86.4461L88.184 89.6291L85 89.1831L85.4459 86Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_1_9185)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_1_9185",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 85,
    y: 86,
    width: 4,
    height: 4
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0379 86.223C86.1588 86.0999 85.3462 86.7119 85.2229 87.592C85.0997 88.4711 85.7129 89.2829 86.592 89.4061C87.4711 89.5293 88.2837 88.9172 88.4069 88.038C88.5302 87.158 87.917 86.3462 87.0379 86.223Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_1_9185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4459 86L88.6299 86.4461L88.184 89.6291L85 89.1831L85.4459 86Z",
    fill: "white"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3651 90.7007C91.5874 89.1139 93.0547 88.0079 94.6415 88.2302C96.2282 88.4525 97.3351 89.9191 97.1128 91.5059C96.8905 93.0926 95.4232 94.1986 93.8365 93.9763C92.2497 93.754 91.1428 92.2874 91.3651 90.7007Z",
    fill: "#D0BEDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourIconFour);
export default __webpack_public_path__ + "static/media/tour_icon_four.733a34c9f3c3718005239cd0ccce1d98.svg";
export { ForwardRef as ReactComponent };